import React from "react";
import "./FeedbackStatus.css";
import { CircleSlash } from "lucide-react";
import Button from "../buttons/Button";

const FeedbackStatus = ({
  icon,
  title,
  description,
  buttonText,
  onAction,
  className = "",
  style,
}) => {
  return (
    <div style={style} className={`feedback-status__empty-state ${className}`}>
      <div className="feedback-status__empty-visual">
        <div className="feedback-status__empty-icon">
          {icon ? icon : <CircleSlash size={48} strokeWidth={1.5} />}
        </div>

        <div className="feedback-status__empty-glow" />
      </div>

      <h2 className="feedback-status__empty-title">{title || "Title"}</h2>
      <div className="feedback-status__empty-text">
        {description || "Description"}
      </div>

      {buttonText && (
        <Button
          style={{ width: "fit-content" }}
          value={buttonText ? buttonText : "Button"}
          onClick={onAction}
        />
      )}
    </div>
  );
};

export default FeedbackStatus;
